import React, { useState } from "react";
import Popup from "reactjs-popup";
import CardWrapper from "./CardWrapper";
import "./DataEstate.scss";
import TableCardSelector from "./TableCardSelector";
import DataTagAllFilesTable from "./DataTagAllFilesTable";
import DataTagUsersTable from "./DataTagUsersTable";
import DataEstateSummary from "./DataEstateCards/DataEstateSummary";
import DataEstateDrives from "./DataEstateDrives";
import DataEstateSizeCard from "./DataEstateCards/DataEstateSizeCard";
import DataEstateRegulatedCard from "./DataEstateCards/DataEstateRegulatedCard";
import DataEstateCategoryCard from "./DataEstateCards/DataEstateCategoryCard";
import DataEstateSensitiveCard from "./DataEstateCards/DataEsateSensitiveCard";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";

export default function DataEstate() {
  const [showSpider, setShowSpider] = useState(false);
  const [showSensitiveBadge, setShowSensitiveBadge] = useState(false);

  const cards = [
    { title: "Summary", component: <DataEstateSummary /> },
    { title: "Size Analysis", component: <DataEstateSizeCard /> },

    {
      title: showSensitiveBadge ? "Sensitivity" : "Regulated",
      component: showSensitiveBadge ? (
        <DataEstateSensitiveCard />
      ) : (
        <DataEstateRegulatedCard />
      ),
      rightElement: (
        <div className="de-regulated-actions">
          {/* Expand */}
          {showSensitiveBadge ? null : (
            <Popup
              modal
              className="de-popup"
              trigger={<span className="de-expand-icon">⤢</span>}
            >
              {(close) => (
                <div className="parent-popup">
                  <div className="de-popup-content">
                  <span className="de-popup-close" onClick={close}>
                    ✕
                  </span>

                  <DataEstateRegulatedCard expanded />
                </div>
                </div>
              )}
            </Popup>
          )}
          <FormControlLabel
            control={
              <Switch
                checked={showSensitiveBadge}
                onChange={() => setShowSensitiveBadge(!showSensitiveBadge)}
                color="primary"
                sx={{
                  transform: "scale(0.8)",
                  marginRight: "-6px",
                }}
              />
            }
          />
        </div>
      ),
    },

    {
      title: "Category",
      component: (
        <DataEstateCategoryCard
          showSpider={showSpider}
          setShowSpider={setShowSpider}
        />
      ),
    },
  ];

  const tabs = [
    { name: "Users", component: <DataTagUsersTable /> },
    { name: "All Files", component: <DataTagAllFilesTable /> },
    { name: "All Drives", component: <DataEstateDrives /> },
  ];

  return (
    <div className="dataEstate-container">
      <div className="de-container">
        {cards.map((card, index) => (
          <CardWrapper
            key={index}
            title={card.title}
            rightElement={card.rightElement}
          >
            {card.component}
          </CardWrapper>
        ))}
      </div>

      <div>
        <TableCardSelector tabs={tabs} />
      </div>
    </div>
  );
}
